import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiService } from '../services/apiService';
import TestResultsDisplay from '../components/TestResultsDisplay';
import type { Test } from '../types';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

const Results: React.FC = () => {
  const { testId } = useParams<{ testId: string }>();
  const [test, setTest] = useState<Test | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { logout } = useAuth();

  useEffect(() => {
    const fetchResults = async () => {
      if (testId) {
        const response = await apiService.getTestById(testId);
        if (response.success && response.data) {
          setTest(response.data as Test);
        }
        setIsLoading(false);
      }
    };

    fetchResults();
  }, [testId, apiService]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800">
        <div className="text-navy-200">Loading...</div>
      </div>
    );
  }

  if (!test || !test.results) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800">
        <div className="text-navy-200">Results not found</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800 p-8">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6 flex justify-end">
          <Button variant="outline" onClick={logout}>
            Logout
          </Button>
        </div>

        <TestResultsDisplay test={test as Test & { user: any }} showUserInfo={true} showTestInfo={true} />

        <div className="flex flex-col sm:flex-row justify-center gap-3 mt-6 print:hidden">
          <Link
            to="/admin/test"
            className="bg-gold-500 hover:bg-gold-600 text-navy-950 px-6 py-3 rounded-lg font-medium text-center"
          >
            Take Another Test
          </Link>
          <Link
            to="/admin/dashboard"
            className="bg-navy-700 hover:bg-navy-800 text-white px-6 py-3 rounded-lg font-medium text-center"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Results;
